import React from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Text from "components/atoms/text/Text";

import { useDevice } from "utils/device";

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-width: 671px;
    height: 48px;
    background-color: var(--color-HighlightYellow);
`;

const WidthLimit = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    width: 100%;
`;

const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const ActionBtn = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    min-width: 80px;
    height: 24px;
    outline: none;
    background-color: transparent;
    border: solid 1px var(--color-White);
    border-radius: 12px;
    transition: all 120ms ease-in;

    &:hover {
        background-color: var(--color-White);

        p {
            color: var(--color-Black);
        }
    }
`;

const BannerText = styled(Text).attrs({
    variant: "body-md-400",
    margin: "0 0 0 12px",
    color: "var(--color-Black)",
})``;

const ButtonText = styled(Text).attrs({
    variant: "body-sm-400",
    color: "var(--color-SubBlack)",
})``;

function AlertBanner(props) {
    const device = useDevice();

    return (
        <Container>
            <WidthLimit device={device}>
                <Row>
                    <Icon name={"warn"} size={"14"} color={"var(--color-Black)"} />
                    <BannerText>{props.alertMessage}</BannerText>
                </Row>
                {(props.showPlan || props.showReSub) && (
                    <ActionBtn
                        onClick={(e) => {
                            props.onAction();
                        }}
                    >
                        <ButtonText>{props.showPlan ? "요금제 확인" : props.showReSub ? "재구독" : ""}</ButtonText>
                    </ActionBtn>
                )}
            </WidthLimit>
        </Container>
    );
}

export default AlertBanner;
